import React from 'react';
import { Box, ToggleButtonGroup, ToggleButton } from '@mui/material';
import { getNotificationCounts } from './NotificationUtils';

const NotificationFilters = ({ 
  activeFilter, 
  handleFilterChange, 
  notificationsList 
}) => {
  const counts = getNotificationCounts(notificationsList);

  return (
    <Box sx={{ mb: 3 }}>
      <ToggleButtonGroup
        value={activeFilter}
        exclusive
        onChange={handleFilterChange}
        aria-label='notification filter'
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 1,
          '& .MuiToggleButton-root': {
            border: '1px solid #e2e8f0',
            borderRadius: '8px',
            textTransform: 'none',
            fontWeight: 500,
            fontSize: '0.875rem',
            minWidth: 'auto',
            padding: '8px 16px',
            '&.Mui-selected': {
              backgroundColor: '#9291ef',
              color: 'white',
              '&:hover': {
                backgroundColor: '#7c7be0',
              },
            },
            '&:hover': {
              backgroundColor: '#f8fafc',
            },
          },
        }}
      >
        <ToggleButton value='all' aria-label='all notifications'>
          All ({counts.total})
        </ToggleButton>
        <ToggleButton value='messages' aria-label='messages'>
          Messages ({counts.messages})
        </ToggleButton>
        <ToggleButton value='videos' aria-label='videos'>
          Videos ({counts.videos})
        </ToggleButton>
        <ToggleButton value='attachments' aria-label='attachments'>
          Attachments ({counts.attachments})
        </ToggleButton>
        <ToggleButton value='goals' aria-label='goals'>
          Goals ({counts.goals})
        </ToggleButton>
        <ToggleButton value='quicktracks' aria-label='quicktracks'>
          QuickTracks ({counts.quicktracks})
        </ToggleButton>
        <ToggleButton value='profiles' aria-label='profiles'>
          Profiles ({counts.profiles})
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};

export default NotificationFilters; 